import { useMutation } from '@tanstack/react-query'

import { bulkImportRampCurves } from '@/features/resource/endpoints/resources'

export function useBulkImportRampCurvesMutation() {
  const mutation = useMutation({
    mutationFn: (file: File) => bulkImportRampCurves(file),
  })

  return {
    bulkImportRampCurves: mutation.mutateAsync,
    ...mutation,
  }
}
